import { render, staticRenderFns } from "./ViewTransactionsHeader.vue?vue&type=template&id=381a1236&scoped=true"
import script from "./ViewTransactionsHeader.vue?vue&type=script&lang=js"
export * from "./ViewTransactionsHeader.vue?vue&type=script&lang=js"
import style0 from "./ViewTransactionsHeader.vue?vue&type=style&index=0&id=381a1236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381a1236",
  null
  
)

export default component.exports